import * as React from 'react';
import * as top from '../img/top.png';
import * as audio from '../elevator.mp3';
import * as endAudio from '../ding.mp3';
import * as privacyPolicy from '../privacy_policy.pdf';
import * as privacyPolicyAdmin from '../privacy_policy_admin.pdf';
import * as termsOfUse from '../terms_of_use.pdf';
import * as termsOfUseGeneral from '../terms_of_use_general.pdf';
import Elevator from 'elevator.js';

const elevator = () => (new Elevator({
    mainAudio: audio,
    endAudio: endAudio
}));
const topClick = (e: any) => {
    e.preventDefault();
    // window.scroll(0, 0);
    elevator().elevate();
};

export const footer = (accountType: string) => {
    const consultant = accountType === 'consultant';
    const admin = accountType === 'admin';
    const termsOfUseHref = consultant ?
        termsOfUse : termsOfUseGeneral;
    const privacyPolicyHref = consultant ? privacyPolicy
        : admin ? privacyPolicyAdmin
        : 'https://cdn2.hubspot.net/hubfs/2155006/Documents/Korum%20Website%20Terms%20of%20Use/Korum%20Privacy%20Policy.pdf?t=1543081498754';
    return (
        <div>
            {accountType ? (
                <a href="#" onClick={topClick}>
                    <img src={top} style={{float: 'right', width: '35px'}}/>
                </a>
            ) : null}
            <div className="span12 widget-span widget-type-cell subFooter text-center mt-5" data-widget-type="cell" data-x="0" data-w="12">
                <div className="row-fluid-wrapper row-depth-1 row-number-2 ">
                    <div className="row-fluid ">
                        <div className="span12 widget-span widget-type-cell page-center" data-widget-type="cell" data-x="0" data-w="12">
                            <div className="row-fluid-wrapper row-depth-1 row-number-3 " style={{marginBottom: '10px'}}>
                                <div className="row-fluid ">
                                    <div className="span12 widget-span widget-type-raw_html socialIcons" data-widget-type="raw_html" data-x="0" data-w="12">
                                        <div className="cell-wrapper layout-widget-wrapper">
                                                <span
                                                    id="hs_cos_wrapper_module_1481619767936732"
                                                    className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_raw_html"
                                                    data-hs-cos-general-type="widget"
                                                    data-hs-cos-type="raw_html"
                                                >
                                                    <a href="https://twitter.com/KorumLegal" className="twitter" style={{margin: '5px'}}>
                                                        <i className="fa fa-twitter" style={{fontSize: '2em'}}/>
                                                    </a>
                                                    {' '}
                                                    <a href="https://www.linkedin.com/company/korumlegal" className="linkedin" style={{margin: '5px'}}>
                                                        <i className="fa fa-linkedin" style={{fontSize: '2em'}}/>
                                                    </a>
                                                    <a href="https://www.facebook.com/KorumLegal/" className="facebook" style={{margin: '5px'}}>
                                                        <i className="fa fa-facebook" style={{fontSize: '2em'}}/>
                                                    </a>
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row-fluid-wrapper row-depth-1 row-number-6 ">
                                <div className="row-fluid ">
                                    <div className="span12 widget-span widget-type-rich_text wrapper" data-widget-type="rich_text" data-x="0" data-w="12">
                                        <div className="cell-wrapper layout-widget-wrapper">
                                                <span id="hs_cos_wrapper_module_1481710583662515" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="rich_text">
                                                    <div className="disclaimer col-md-12  text-center">The KorumLegal Group is a legal solutions company.  The KorumLegal entities do not provide legal advice.</div>
                                                    <p>Copyright ©&nbsp;
                                                        <span>Korum Consulting Limited (t/a KorumLegal)&nbsp;{(new Date()).getFullYear()}</span>. All Rights Reserved.</p>
                                                    <p>
                                                        <a href={termsOfUseHref} target="_blank" style={{margin: '5px'}}>Terms of Use</a>
                                                        <a href={privacyPolicyHref} target="_blank" style={{margin: '5px'}}>Privacy Policy</a>
                                                    </p>
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/widgets/Footer.tsx